import { TbRocket } from "react-icons/tb";
import { TbTool } from "react-icons/tb";
import { TbTrophy } from "react-icons/tb";


export const milestones = [
    {
        icon: <TbRocket/>,
        title: `Successfully led the complete development cycle of multiple projects, transforming initial concepts into fully functional, high-performance applications.`
    },
    {
        icon: <TbTool/>,
        title: `Reinvigorated and optimized numerous legacy applications, significantly improving functionality and user experience, resulting in increased user satisfaction and retention.` 
    },
    {
        icon: <TbTrophy/>,
        title: `Recognized as Frontend Specialist of the Year for exceptional expertise in resolving critical bugs and enhancing the user experience during a high-stakes rebranding project.`
    }
]